import { n as e, t } from "./BlockNoteExtension-BBlRdZNO.js";
//#region src/extensions/Versioning/Versioning.ts
function n(e) {
	return [...e].sort((e, t) => t.createdAt - e.createdAt);
}
var r = t(({ options: t, editor: r }) => {
	let { endpoints: i, preview: a, getCurrentState: o } = typeof t == "function" ? t(r) : t, s = e({
		snapshots: [],
		previewedSnapshotId: void 0
	}), c = async () => {
		let e = n(await i.list());
		s.setState((t) => ({
			...t,
			snapshots: e
		}));
	}, l = async (e, t) => {
		s.setState((t) => ({
			...t,
			previewedSnapshotId: e
		}));
		let n;
		t?.compareTo && (n = await i.getContent(t.compareTo));
		let r = await i.getContent(e);
		a.enterPreview(r, n);
	}, u = () => {
		s.setState((e) => ({
			...e,
			previewedSnapshotId: void 0
		})), a.exitPreview();
	};
	return {
		key: "versioning",
		store: s,
		listSnapshots: async () => (await c(), s.state.snapshots),
		createSnapshot: async (e) => {
			let t = await i.create(o(), e);
			return s.setState((e) => ({
				...e,
				snapshots: n([...e.snapshots, t])
			})), t;
		},
		canRestoreSnapshot: i.restore !== void 0,
		restoreSnapshot: i.restore ? async (e) => {
			u();
			let t = await i.restore(o(), e);
			return a.applyRestore(t), await c(), t;
		} : void 0,
		canUpdateSnapshotName: i.updateSnapshotName !== void 0,
		updateSnapshotName: i.updateSnapshotName ? async (e, t) => {
			await i.updateSnapshotName(e, t), s.setState((n) => ({
				...n,
				snapshots: n.snapshots.map((n) => n.id === e ? {
					...n,
					name: t,
					updatedAt: Date.now()
				} : n)
			}));
		} : void 0,
		previewSnapshot: l,
		exitPreview: u
	};
});
//#endregion
export { n, r as t };

//# sourceMappingURL=Versioning-DwxehEWi.js.map